import styled from "styled-components"

export default styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.25rem 1rem;
  margin: 0 auto;
  border-radius: 4px;
  font-weight: 600;
  text-transform: capitalize;
  cursor: pointer;
  &:hover {
    opacity: 0.9;
  }
`
